export enum NotificationEventType {
  GENERIC = 'GENERIC',
  PROJECT_CALCULATION_FINISHED = 'PROJECT_CALCULATION_FINISHED',
  PROJECT_RENDER_BAKING_FINISHED = 'PROJECT_RENDER_BAKING_FINISHED',
  LAMP_SIMILARITY_FINISHED = 'LAMP_SIMILARITY_FINISHED',
  CATALOGUE_SYNC_FINISHED = 'CATALOGUE_SYNC_FINISHED',
}

export enum CatalogueSyncStatus {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
}

interface GenericNotification {
  type: NotificationEventType.GENERIC;
  payload?: unknown;
}

export interface ProjectCalculationFinishedNotification {
  type: NotificationEventType.PROJECT_CALCULATION_FINISHED;
  projectId: number;
  projectName: string;
  versionId: number;
  versionName: string;
  status: string;
}

export interface ProjectRenderBakingFinishedNotification {
  type: NotificationEventType.PROJECT_RENDER_BAKING_FINISHED;
  projectId: number;
  projectName: string;
  versionId: number;
  versionName: string;
  status: string;
}

export interface LampSimilarityFinishedNotification {
  type: NotificationEventType.LAMP_SIMILARITY_FINISHED;
  projectId: number;
  projectName: string;
  versionId: number;
  versionName: string;
  status: string;
}

export interface CatalogueSyncFinishedNotification {
  type: NotificationEventType.CATALOGUE_SYNC_FINISHED;
  status: CatalogueSyncStatus;
  commitSha: string | null;
  errorMessage: string | null;
}

type NotificationEvent =
  | GenericNotification
  | ProjectCalculationFinishedNotification
  | ProjectRenderBakingFinishedNotification
  | LampSimilarityFinishedNotification
  | CatalogueSyncFinishedNotification;

export interface NotificationResponse {
  id: number;
  event: NotificationEvent;
  createdAt: string;
  readAt: string | null;
}

export interface NotificationsMarkAsReadRequest {
  ids: number[];
}
